import find from 'lodash/find';
import last from 'lodash/last';
import size from 'lodash/size';

export class DashboardService {
	constructor(AuthService, ApiService, $resource, $cookies, BreadcrumbService) {
		'ngInject';

		this.authService = AuthService;
		this.apiService = ApiService;
		this.$resource = $resource;
		this.$cookies = $cookies;
		this.breadcrumbService = BreadcrumbService;

		this.menuListResourceUrl = this.apiService.getResourceUrl('cms/menus');
		this.menuListResource = this.$resource(this.menuListResourceUrl);
	}

	_getMenuDetails(value) {
		return {
			id: value.cms_menu_id,
			name: value.name,
			displayName: value.display_name,
			icon: value.icon,
			slug: value.slug || null
		}
	}

	_getMenuList1Details(content) {
		return content.reduce((list, data) => {
			if (data.menu_group === '1') {
				list = list.concat(_getListData.call(this, data.value));
			}
			return list;
		}, []);

		function _getListData(data) {
			return data.map(value => this._getMenuDetails(value))
		}
	}

	_getMenuList2Details(content) {
		return content.reduce((list, data) => {
			list = _getListData.call(this, data.value);
			return list;
		}, []);

		function _getListData(data) {
			return data.map(value => this._getMenuDetails(value));
		}
	}
	/**
	 * function to get menu list
	 * @return {object} [information related to menu list]
	 */
	getMenuList() {
		let menuListDetails = this.$cookies.get('menuList');
		if (!menuListDetails) {
			const promise = this.menuListResource.get().$promise;
			return promise.then(details => {
				let menulist = {
					menuList1: this._getMenuList1Details(details.data),
					menuList2: this._getMenuList2Details(details.data)
				}
				this.$cookies.put('menuList', JSON.stringify(menulist));
				return menulist;
			}).catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
		} else {
			return JSON.parse(menuListDetails)
		}
	}

	updateMenuSlug({ name, display_name: displayName, slug: updatedSlug }) {
		let menuListDetails = JSON.parse(this.$cookies.get('menuList'));
		let menu = this._getMenuToUpdate(menuListDetails.menuList1, name);
		if (menu) {
			menu.slug = updatedSlug;
			menu.displayName = displayName;
			this.$cookies.put('menuList', JSON.stringify(menuListDetails));
		}
	}

	getActiveMenuName() {
		const breadcrumbs = this.breadcrumbService.breadcrumbs;
		return size(breadcrumbs) > 0 ? last(breadcrumbs).displayName : null;
	}

	_getMenuToUpdate(menuList, menuName) {
		return find(menuList, { name: menuName })
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.service.js